import {
  useQuery,
  UseQueryOptions,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { ID, IdProvider, Timestamp, unwrap } from '../common/apiCommons';
import axios from 'axios';

export const LOGOUT_WARNING = 'logoutWarning';

export interface LogoutWarning {
  type: string;
  id: ID;
  seen_by_admin: boolean;
  resolved: boolean;
  employee: ID;
  date: ID;
  reason: string;
}

type LogoutWarningQueryParams = IdProvider & {
  start: Timestamp;
  end: Timestamp;
};
const queries = {
  async getEmployeeWarnings(request: LogoutWarningQueryParams) {
    if (!request.id) {
      return null;
    }
    const res = await axios.get<LogoutWarning[]>(
      `/warnings/ignored_logout_timer/?employee=${request.id}&start=${request.start}&end=${request.end}`,
    );
    return unwrap(res);
  },
};

const mutations = {
  async seenWarning(warning: LogoutWarning) {
    const res = await axios.post<void>(
      `/warnings/ignored_logout_timer/seen/${warning.id}/`,
    );
    return unwrap(res);
  },
};

const hooks = {
  useEmployeeWarnings(
    request: LogoutWarningQueryParams,
    options?: UseQueryOptions<LogoutWarning[] | null>,
  ) {
    return useQuery({
      queryKey: [LOGOUT_WARNING, request.id, request.start, request.end],
      queryFn: () => queries.getEmployeeWarnings(request),
      enabled: !!request && !!request.start && !!request.end && !!request.id,
      ...(options ?? {}),
    });
  },
  useAdminHasSeenWarning() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: mutations.seenWarning,
      onSuccess: async (_data, params) => {
        await queryClient.invalidateQueries([LOGOUT_WARNING, params.employee]);
      },
    });
  },
};

const LogoutWarningApi = { queries, mutations, hooks };

export default LogoutWarningApi;
